import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-de11d214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ccn-cookie-list-entry" }

import { ICookieListEntry } from '../../common/interfaces/index.interface';
  import { ETextSize, EToggleSize } from '../../common/enums/index.enum';
  import AdditionalInformation from './AdditionalInformation.vue';
  import ExplanationParagraph from './ExplanationParagraph.vue';
  import HeadlineWithToggle from './CustomHeadlineWithToggle.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CookieListEntry',
  props: {
    disabled: { type: Boolean, default: false },
    entry: {}
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(HeadlineWithToggle, {
      active: _ctx.entry.active,
      clickable: "",
      disabled: _ctx.disabled,
      size: _unref(ETextSize).XS,
      text: _ctx.$t(_ctx.entry.title),
      "toggle-size": _unref(EToggleSize).XS,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:active-single-cookie`, { active: $event, cookieName: _ctx.entry.internalIdentifier })))
    }, null, 8, ["active", "disabled", "size", "text", "toggle-size"]),
    (_ctx.entry.explanation)
      ? (_openBlock(), _createBlock(ExplanationParagraph, {
          key: 0,
          size: _unref(ETextSize).SM,
          text: _ctx.$t(_ctx.entry.explanation)
        }, null, 8, ["size", "text"]))
      : _createCommentVNode("", true),
    _createVNode(AdditionalInformation, {
      size: _unref(ETextSize).SM,
      text: _ctx.$t(_ctx.entry.responsible),
      title: _ctx.$t(`${_ctx.$translationsUfeNamespace}cookieDetails.responsible`)
    }, null, 8, ["size", "text", "title"]),
    _createVNode(AdditionalInformation, {
      size: _unref(ETextSize).SM,
      text: _ctx.$t(_ctx.entry.privacy),
      title: _ctx.$t(`${_ctx.$translationsUfeNamespace}cookieDetails.privacy`)
    }, null, 8, ["size", "text", "title"]),
    _createVNode(AdditionalInformation, {
      size: _unref(ETextSize).SM,
      text: _ctx.$t(_ctx.entry.cookieNames),
      title: _ctx.$t(`${_ctx.$translationsUfeNamespace}cookieDetails.cookieNames`)
    }, null, 8, ["size", "text", "title"]),
    _createVNode(AdditionalInformation, {
      size: _unref(ETextSize).SM,
      text: _ctx.$t(_ctx.entry.duration),
      title: _ctx.$t(`${_ctx.$translationsUfeNamespace}cookieDetails.duration`)
    }, null, 8, ["size", "text", "title"])
  ]))
}
}

})